import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import classNames from 'classnames';
// import { ACCOUNT_SETTINGS_PAGES } from '../../routeConfiguration';
import { propTypes } from '../../util/types';
import { Avatar, Logo, NamedLink } from '../../components';
import { TopbarSearchForm } from '../../forms';

import css from './TopbarDesktop.css';

import user from './user.png';

import MenuDrawer from './MenuDrawer';

//Language selector copy here from MenuDrawer.js for Desktop
//These 4 import and 1 cookie are related to language selector
//Edit by Karim: The language cookie is set to de by default in index.js
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Cookies from 'universal-cookie';
import selecticon from '../../assets/icons/languages-bw.webp';
const cookies = new Cookies();

const TopbarDesktop = props => {
  const {
    // state,
    className,
    currentUser,
    // currentPage,
    rootClassName,
    currentUserHasListings,
    notificationCount,
    intl,
    isAuthenticated,
    onLogout,
    onSearchSubmit,
    initialSearchFormValues,
  } = props;

  const [mounted, setMounted] = useState(false);
  const [sectionOne, setSectionOne] = useState(true);
  const [sectionTwo, setSectionTwo] = useState(false);


  useEffect(() => {
    //console.log(section);
    window.onscroll = function () {
      if (window.pageYOffset * 2 < window.innerHeight) {
        setSectionTwo(false);
        setSectionOne(true);
        //console.log('Scrolling ' + sectionOne);
      } else {
        setSectionOne(false);
        setSectionTwo(true);
        if (window.pageYOffset > window.innerHeight * 0.6) {
          setSectionTwo(true);
        } else {
          setSectionTwo(false);
        }
      }
    };
  }, []);

 useEffect(() => {
  if(!cookies.get('language')){
    cookies.set('language', 'de', {
    path: '/',
    maxAge: 60 * 60 * 24 * 90
  });
  
  if (typeof window !== 'undefined') window.location.reload();
  console.log('language set to before cookie',  cookies.get('language'));
  
  }
  setMounted(true);
   return () => {
     
   }
 }, [mounted])
 
  
  //Language selector

  
  
  
 
  const [lang, setLang] = cookies.get('language');
 
  const languageOptions =
  
  cookies.get('language') === 'en' ? (
    
      <>
        <option value="Englisch">{intl.formatMessage({ id: 'languageSetting.english' })}</option>
        <option value="Deutsch">{intl.formatMessage({ id: 'languageSetting.german' })}</option>{' '}
      </>
    ) : (
      <>
        <option value="Deutsch">{intl.formatMessage({ id: 'languageSetting.german' })}</option>
        <option value="Englisch">{intl.formatMessage({ id: 'languageSetting.english' })}</option>
      </>
    )

 

  const handleChange = async event => {
    if (event.target.value === 'Englisch') {

      cookies.set('language', 'en', {
        path: '/',
        maxAge: 60 * 60 * 24 * 90
      });
      if (typeof window !== 'undefined') window.location.reload();

    } else {
      cookies.set('language', 'de', {
        path: '/',
        maxAge: 60 * 60 * 24 * 90
      });
      if (typeof window !== 'undefined') window.location.reload();

    }
  };
  //End of Language Selector

  const authenticatedOnClientSide = mounted && isAuthenticated;
  const isAuthenticatedOrJustHydrated = isAuthenticated || !mounted;

  const classes = classNames(rootClassName || css.root, className);


  let mediaQuery = '';

  if (typeof window !== 'undefined') mediaQuery = window.matchMedia('(min-width: 768px)');


  const search = (
    <TopbarSearchForm
      className={

        typeof window !== 'undefined'

          ? window.location.pathname === '/s'
            ? css.searchLink_active
            : css.searchLink
          : css.searchLink
      }
      desktopInputRoot={css.topbarSearchWithLeftPadding}
      onSubmit={onSearchSubmit}
      initialValues={initialSearchFormValues}
    />
  );

  const becomePartner =
    !isAuthenticatedOrJustHydrated && mediaQuery.matches ? (
      <div
        className={

          typeof window !== 'undefined'

            ? window.location.pathname === '/' ||
              window.location.pathname === '/about' ||
              window.location.pathname === '/FAQ' ||
              window.location.pathname === '/Contact'
              ? css.becomePartnerWrapper
              : css.becomePartnerWrapper_hide
            : css.becomePartnerWrapper_hide
        }
      >
        <NamedLink
          className={

            typeof window !== 'undefined'
              ? window.location.pathname === '/I'
                ? css.active
                : css.becomePartnerLink
              : css.becomePartnerLink
          }
          name="BecomeHostPage"

        >
          <span className={css.becomePartner}>
            <FormattedMessage id="TopbarDesktop.becomePartner" />
          </span>
        </NamedLink>
      </div>
    ) : null;

  const notificationDot = notificationCount > 0 ? <div className={css.notificationDot} /> : null;

  const inboxLink =
    authenticatedOnClientSide && mediaQuery.matches ? (
      <NamedLink
        className={css.inboxLink}
        name="InboxPage"
        params={{ tab: currentUserHasListings ? 'sales' : 'orders' }}
      >
        <span className={css.inbox}>
          <FormattedMessage id="TopbarDesktop.inbox" />
          {notificationDot}
        </span>
      </NamedLink>
    ) : null;

  const profileMenu =
    authenticatedOnClientSide && mediaQuery.matches ? (
      <NamedLink
        name="ProfileSettingsPage"
        className={

          typeof window !== 'undefined'

            ? window.location.pathname === '/profile-settings' ||
              window.location.pathname === '/listings' ||
              window.location.pathname === '/account/contact-details' ||
              window.location.pathname === '/account/change-password'
              ? css.active
              : css.signupLink
            : css.signupLink
        }
      >
        <Avatar className={css.avatar} user={currentUser} disableProfileLink />
      </NamedLink>
    ) : null;

  const loginLink =
    !isAuthenticatedOrJustHydrated && mediaQuery.matches ? (
      <NamedLink
        name="LoginPage"
        className={

          typeof window !== 'undefined'

            ? window.location.pathname === '/login'
              ? css.active
              : css.loginLink
            : css.loginLink
        }
      >
        <img src={user} className={css.userIcon} alt=""></img>
      </NamedLink>
    ) : null;

  const checkDestinations = mediaQuery.matches ? (
    <div
      className={
        /* window.location.pathname === '/l/:slug/:id' ||
        window.location.hash === '#sectionTwo' ||
        window.location.hash === '#sectionThree' ||
        window.location.hash === '#sectionFour' ||
        window.location.hash === '#sectionFive' ||
        window.location.hash === '#sectionSix' ||
        window.location.hash === '#sectionSeven'
          ? css.check
          : css.check_hide*/


        typeof window !== 'undefined'

          ? window.location.pathname === '/l/:slug/:id' ||
            ((window.location.pathname === '/' || window.location.pathname === '/about') &&
              sectionTwo)
            ? css.check
            : css.check_hide
          : css.check_hide
      }
    >
      <NamedLink
        name="SearchPage"
        to={{ search: '?bounds=85.051129%2C179.00736739%2C-75.14077719%2C-160.60200761' }}
        className={css.heroButton}
      >
        <FormattedMessage id="TopbarDesktop.destinationsCTA" />
      </NamedLink>
    </div>
  ) : (
    <div
      className={
        /*window.location.hash === '#sectionTwo' ||
        window.location.hash === '#sectionThree' ||
        window.location.hash === '#sectionFour' ||
        window.location.hash === '#sectionFive' ||
        window.location.hash === '#sectionSix' ||
        window.location.hash === '#sectionSeven'
          ? css.check
          : css.check_hide*/

        typeof window !== 'undefined'

          ? window.location.pathname === '/l/:slug/:id' ||
            ((window.location.pathname === '/' || window.location.pathname === '/about') &&
              sectionTwo)
            ? css.check
            : css.check_hide

          : css.check_hide

      }
    >
      <NamedLink name="SearchPage" className={css.heroButton}>
        <FormattedMessage id="TopbarDesktop.destinationsCTAshort" />
      </NamedLink>
    </div>
  );

  return (
    <nav
      /*className={
        (window.location.pathname === '/' && window.location.hash === '#sectionZero') ||
        (window.location.pathname === '/about' && window.location.hash === '#sectionZero') ||
        (window.location.pathname === '/' && window.location.hash === '') ||
        (window.location.pathname === '/about' && window.location.hash === '')
          ? css.root
          : css.rootPaper
      } */

      className={

        typeof window !== 'undefined'
          ? (window.location.pathname === '/' || window.location.pathname === '/about') &&
            sectionOne
            ? css.root
            : css.rootPaper
          : css.rootPaper
      }
    >
      <NamedLink className={css.logoLink} name="LandingPage">
        <Logo
          format="desktop"
          className={css.logo}
          alt={intl.formatMessage({ id: 'TopbarDesktop.logo' })}
        />
      </NamedLink>

      <div className={css.searchOuter}>{search}</div>


      {checkDestinations}
      {inboxLink}
      {profileMenu}
      <div>
        {becomePartner}
      </div>
      {loginLink}


      <div
        className={css.line}
        style={{
          float: 'left',
        }}
      ></div>

      <div>
        <MenuDrawer
          props={props}
          authenticatedOnClientSide={authenticatedOnClientSide}
          currentUserHasListings={currentUserHasListings}
          notificationCount={notificationCount}
          onLogout={onLogout}
          intl={intl}
        ></MenuDrawer>
      </div>


      <div>
        <FormControl
          className="formControllLanguage"
          style={{
            height: 72,
            fontSize: 14
          }}
        >
          <Select
            native
            value={lang}
            onChange={handleChange}
            className={css.languageSelector}
            backdropprops={{ classes: { root: css.SelectRoot } }}
            paperprops={{ classes: { root: classes.SelectPaper } }}
            IconComponent={() => (
              <img
                src={selecticon}
                height="25px"
                width="30px"                     
                style={{ marginTop: '0px', marginLeft: '-30px', pointerEvents: 'none' }}
                alt=""
              ></img>
            )}
            style={{
              marginTop: 22,
              marginRight: 18,
              fontWeight: 500,
              fontSize: 14,
              color: '#4a4a4a',
              fontFamily: 'Poppins, Helvetica, Arial, sans-serif',
            }}
          >
            {languageOptions}
          </Select>
        </FormControl>
      </div>

    </nav>
  );
};

const { bool, func, object, number, string } = PropTypes;

TopbarDesktop.defaultProps = {
  rootClassName: null,
  className: null,
  currentUser: null,
  currentPage: null,
  notificationCount: 0,
  initialSearchFormValues: {},
};

TopbarDesktop.propTypes = {
  rootClassName: string,
  className: string,
  currentUserHasListings: bool.isRequired,
  currentUser: propTypes.currentUser,
  currentPage: string,
  isAuthenticated: bool.isRequired,
  onLogout: func.isRequired,
  notificationCount: number,
  onSearchSubmit: func.isRequired,
  initialSearchFormValues: object,
  intl: intlShape.isRequired,
};

export default TopbarDesktop;
